import React, { useEffect, useState } from 'react';
import { FieldRenderProps } from 'react-final-form';
import SelectMulti from '../SelectMutli';
import Checkbox from '../Checkbox';
import { useLazyQuery } from '@apollo/client';
import { USERS_QUERY } from './query';

const NotifyAdditionalUsersField = ({ input, optional }: FieldRenderProps<any>) => {
  const [users, setUsers] = useState([]);
  const [getUsers, { loading: gettingUsers }] = useLazyQuery(USERS_QUERY, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => setUsers(data.users),
  });
  useEffect(() => {
    if (!optional || input.value.required) getUsers();
  }, [getUsers, input.value.required, optional]);

  const handleRequiredOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    input.onChange({ ...input.value, required: event.target.checked });
  };

  const handlePersonOnChange = (value: any) => {
    input.onChange({ ...input.value, person: value });
  };

  return (
    <div>
      {optional && (
        <div className="mb-3">
          <Checkbox
            label="Notify additional users"
            checked={input.value.required}
            onChange={handleRequiredOnChange}
          />
        </div>
      )}
      {(!optional || input.value.required) && (
        <div>
          <div className="mb-3">
            <p>People</p>
            <SelectMulti
              loading={gettingUsers}
              options={users.map((user: any) => ({ label: user.name, value: user.id }))}
              value={input.value.person}
              onChange={handlePersonOnChange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

NotifyAdditionalUsersField.defaultProps = {
  optional: true,
};

export default NotifyAdditionalUsersField;
